'use client';

import { BaseModal } from './BaseModal';
import { DaemonTriggerDetailContent, type DaemonTriggerDetailProps } from './DaemonTriggerDetailContent';

export default function DaemonTriggerDetailModal(props: DaemonTriggerDetailProps) {
  return (
    <BaseModal
      isOpen={props.isOpen}
      onClose={props.onClose}
      variant="bottomSheet"
      size="full"
      zIndex="overlay"
      height="h-[calc(86dvh-env(safe-area-inset-bottom))]"
      className="!p-0 flex flex-col overflow-hidden"
    >
      <DaemonTriggerDetailContent {...props} />
    </BaseModal>
  );
}
